export const environment = {
  production: true,
  baseURL: 'https://site-companion-api.mosaic-qa.siemens-energy.cloud'
};
